import React, { Component } from 'react';
import {Dropdown} from 'semantic-ui-react';
import * as esriLoader from 'esri-loader';

export default class FilterComponent extends Component {

    render() {
        const { filterName, filterText, filters, isFetching } = this.props;

        const availableFilters = filters.map(
            (filter) => {
                return {
                    key: filter.name,
                    text: filter.name,
                    value: filter.name
                }
            }
        );
        const selectedFilters = filters.filter(
            filter => filter.selected
        ).map(
            (filter) => filter.name
        );

        let displayText = "";
        switch(filterText) {
            case "Hist_Dist":
                displayText = "a Historic District(s)";
                break;
            case "LM_New":
                displayText = "an Individual Landmark(s)";
                break;
            case "Style_Prim":
                displayText = "a Primary Building Style";
                break;
            case "Arch_Build":
                displayText = "an Architect / Builder";
                break;
            case "Build_Type":
                displayText = "an Original Building Type";
                break;
            case "ERA":
                displayText = " Era of Construction";
                break;

            default:
                displayText = "Unknown";
        }

        return (
            <div>
                <div>Select {displayText}</div>
                <Dropdown
                    fluid
                    selection
                    wrapSelection={false}
                    multiple={true}
                    search={true}
                    options={availableFilters}
                    value={selectedFilters}
                    placeholder={'All'}
                    onChange={this.handleChange.bind(this)}
                    disabled={isFetching}
                    loading={isFetching}
                />
                <br />
            </div>
        );
    }

    handleChange(event, data) {
        this.props.handleUpdate(this.props.filterName, data.value);
        //todo later when we move to flux
        //dispatch update
        // update the store
        // update the other filters
        // update the results
    }
}
